export const bioData = [
    {
        title: "View Matt's Bio",
        content: `
        Matt Fredericksen creates a unique fusion of energetic riffs, rhythmic lyrics, and catchy melodies that touches on diverse genres of music. His primarily indie-rock vibe reflects an influence of artists like Dave Matthews Band, Jason Mraz, Phillip Phillips, and the Goo Goo Dolls. Matt is from the Chicago area, but he now resides in Nashville, TN where he focuses on songwriting all genres.
        You can stay updated on Matt and his music through his Facebook, Instagram, and YouTube page "Matt Fredericksen Music".    
        `
    }
]